// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23sKl","rootNoMargin":"styles_rootNoMargin__joc24"};